<div class="modal-header">
    <h3 class="modal-title">{{modalText}}</h3>
    <button type="button" class="btn-close" aria-label="Close" style="color: white;" (click)="dimissModal()">
    </button>
</div>
<div class="outerbody">
    <form [formGroup]="chargeBalanceForm">
        <div class="modal-body">
            <div class="d-flex align-items-center">
                <label class="label-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.TOTAL_CATIONS </label>
                <input class="cb-input mt-1 mb-1 disabled" type="text" formControlName="totalCations">
                <span class="span-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.UNIT </span>
            </div>
            <div class="d-flex align-items-center">
                <label class="label-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.TOTAL_ANIONS </label>
                <input class="cb-input mt-1 mb-1 disabled" type="text" formControlName="totalAnions">
                <span class="span-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.UNIT </span>
            </div>
            <div class="d-flex align-items-center">
                <label class="label-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.DIFFERENCE </label>
                <input class="cb-input mt-1 mb-1 disabled" type="text" formControlName="difference">
                <span class="span-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.UNIT </span>
            </div>
            <div class="d-flex align-items-center selectRow">
                <label class="label-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.BALANCE_WITH </label>
                <select class="dropDown cb-input p-2" formControlName="balance" (change)="onChangeBalance()">
                    <option *ngFor="let dropDown of result.IonBalanceTypes" [value]="dropDown.Name">{{dropDown.Name}}
                    </option>
                </select>
            </div>
            <div class="d-flex align-items-center">
                <label class="label-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.BALANCE_WITH </label>
                <input class="cb-input mt-1 mb-1 disabled" type="text" formControlName="balanceValue">
                <span class="span-class" translate>RO_OPTIMIZER.CHARGE_BALANCE.UNIT </span>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <div>
        <button type="button" class="btn btn-secondary" (click)="dimissModal()" translate>COMMON.CANCEL</button>
        <button type="button" class="btn btn-primary" (click)="submitChargeModal()" translate>COMMON.OK</button>
    </div>
</div>